<template>
  <expansion-panel
    key="expansion-panel-customer-data"
    :hideDivider="panelHideDivider"
    :readonly="panelReadonly"
    :title="$t('offer-manager.create.step-customer-data.title')">
    <template v-slot:panel-content>
      <contact-form
        v-model="contact"
        :country="country"
        :disabled="disabled"
        :first-name-required="!isSubagent"
        :focus="focus"
        :invalid-emails="invalidEmails"
        :last-name-required="!isSubagent"
        :phone-number-required="!isSubagent"
        :phone-readonly="!isSubagent && !isOfferFromLead"
        :required-true-check="!isSubagent"
        @validateForm="validateForm"
        country-disabled />
    </template>
  </expansion-panel>
</template>

<script lang="ts">
import {OfferType} from '@muvio/honda-offers-builder/model'
import {computed, defineComponent, inject, onMounted} from '@vue/composition-api'

import ContactForm from '@/components/contact/ContactForm.vue'
import ExpansionPanel from '@/components/general/ExpansionPanel.vue'
import {ContactWithExtras} from '@/types'
import {mapGetters} from '@/utils/map-store'

export default defineComponent({
  name: 'CustomerData',
  components: {ContactForm, ExpansionPanel},
  props: {
    panelReadonly: Boolean,
    panelHideDivider: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    focus: {
      type: String,
      default: null,
      required: false,
    },
  },
  inject: ['leadId'],
  setup(props, {root, emit}) {
    const leadId = inject('leadId')

    const {getUser: user, getCountry: country, getOfferType: offerType} = mapGetters(root.$store.getters)

    const isSubagent = computed(() => {
      return offerType.value === OfferType.subagent || false
    })

    const invalidEmails = computed(() => [user.value.login])

    const contact = computed({
      get: (): ContactWithExtras => root.$store.getters.getOfferContact,
      set: (value: ContactWithExtras) => {
        if (!value?.address?.addressCountry) value.address.addressCountry = country.value
        root.$store.dispatch('prepareOfferContact', value)
      },
    })

    onMounted(() => {
      root.$store.dispatch('clearOfferContact')
    })

    function validateForm() {
      emit('validateForm')
    }

    return {
      user,
      country,
      invalidEmails,
      isSubagent,
      isOfferFromLead: !!leadId,
      contact,
      validateForm,
    }
  },
})
</script>
